import type { ReactNode } from "react";
import { AnimatePresence, type TransitionProp } from "tamagui";
import { YStack } from "../Stacks";
import { appear } from "./motion";
import { PresenceSlot } from "./PresenceSlot";
export type CrossfadeProps = {
  stateKey: string;
  /** Overrides the fade's transition, for a beat the user should see land. */
  transition?: TransitionProp;
  /** Fill the parent row, for a slot inside an XStack. */
  flex?: boolean;
  children: ReactNode;
};
const fade = appear("fade");

/** Keyed content swap in place: the leaving child fades out over the arriving one. */
export const Crossfade = ({
  stateKey,
  transition,
  flex,
  children
}: CrossfadeProps) => <YStack position="relative" width="100%" flex={flex ? 1 : undefined} data-sentry-element="YStack" data-sentry-component="Crossfade" data-sentry-source-file="Crossfade.tsx">
    <AnimatePresence initial={false} data-sentry-element="AnimatePresence" data-sentry-source-file="Crossfade.tsx">
      <PresenceSlot key={stateKey} flex={flex} {...fade} transition={transition ?? fade.transition} data-sentry-element="PresenceSlot" data-sentry-source-file="Crossfade.tsx">
        {children}
      </PresenceSlot>
    </AnimatePresence>
  </YStack>;